import { useMemo, useState } from "react";
import AdminLayout from "@/components/admin/AdminLayout";
import AthleteHubHome, { type Hub } from "@/components/athlete/AthleteHubHome";
import { STAGE_LABEL, type Stage } from "@/lib/athleteHub";

/**
 * Admin visual QA: the athlete Home dashboard in each lifecycle stage, rendered
 * from in-memory fixtures. Nothing is read from or written to the database.
 */
const base = {
  id: "fixture-athlete", slug: "jen-crompton-test", name: "Jordan Fixture", sport: "Soccer",
  tagline: "Defender who coaches the next generation.", bio: "<p>Fixture story copy.</p>",
  image_path: null as string | null, instagram_url: "https://instagram.com/example",
} as any;

const inquiries = [
  { id: "i1", company: "Hometown Sports Co.", opportunity_type: "Appearance", estimated_budget: "$500–$1,000", timing: "November", description: "Youth clinic appearance for our store opening.", status: "new", created_at: "2026-10-01T12:00:00Z" },
  { id: "i2", company: "Local Bakery", opportunity_type: "Social post", estimated_budget: null, timing: null, description: null, status: "reviewed", created_at: "2026-09-12T12:00:00Z" },
];

const STATES: Record<Exclude<Stage, "invited">, { hub: Hub; athlete: any; shop: string | null }> = {
  started: {
    athlete: { ...base, tagline: null, bio: null, published: false },
    shop: null,
    hub: { stage: "started", quick_start_submitted_at: null, module_choices: {}, approved_current_version: false, approved_at: null,
      consents: { profile_publication: false, photo_likeness: false }, follower_count: 0, inquiries: [], changes_requested: null },
  },
  siis_review: {
    athlete: { ...base, published: false },
    shop: null,
    hub: { stage: "siis_review", quick_start_submitted_at: "2026-10-02T12:00:00Z", module_choices: { highlights: true, her_collection: "interested" }, approved_current_version: false, approved_at: null,
      consents: { profile_publication: true, photo_likeness: true }, follower_count: 3, inquiries: [], changes_requested: null },
  },
  athlete_approval: {
    athlete: { ...base, published: false, image_path: "x.jpg" },
    shop: null,
    hub: { stage: "athlete_approval", quick_start_submitted_at: "2026-10-02T12:00:00Z", module_choices: { her_collection: "not_now" }, approved_current_version: false, approved_at: null,
      consents: { profile_publication: false, photo_likeness: false }, follower_count: 5, inquiries: inquiries.slice(0, 1), changes_requested: null },
  },
  ready: {
    athlete: { ...base, published: false, image_path: "x.jpg" },
    shop: null,
    hub: { stage: "ready", quick_start_submitted_at: "2026-10-02T12:00:00Z", module_choices: { her_collection: "interested" }, approved_current_version: true, approved_at: "2026-10-04T12:00:00Z",
      consents: { profile_publication: true, photo_likeness: true }, follower_count: 8, inquiries: inquiries.slice(0, 1), changes_requested: null },
  },
  published: {
    athlete: { ...base, published: true, image_path: "x.jpg", support_enabled: true },
    shop: null,
    hub: { stage: "published", quick_start_submitted_at: "2026-10-02T12:00:00Z", module_choices: { her_collection: "interested" }, approved_current_version: true, approved_at: "2026-10-04T12:00:00Z",
      consents: { profile_publication: true, photo_likeness: true }, follower_count: 42, inquiries, changes_requested: null },
  },
};

const AdminDashboardStates = () => {
  const [stage, setStage] = useState<keyof typeof STATES>("started");
  const s = STATES[stage];
  const fixture = useMemo(() => ({ hub: s.hub, shopStatus: s.shop }), [s]);
  return (
    <AdminLayout>
      <div className="space-y-4">
        <div>
          <h1 className="font-display text-3xl">Athlete Home — stage preview</h1>
          <p className="mt-1 text-sm text-muted-foreground">Sample data only. Nothing is saved and all actions are disabled.</p>
        </div>
        <div className="flex flex-wrap gap-2" role="group" aria-label="Lifecycle stage">
          {(Object.keys(STATES) as (keyof typeof STATES)[]).map((k) => (
            <button key={k} type="button" aria-pressed={stage === k} onClick={() => setStage(k)}
              className={`min-h-[44px] rounded-full border px-4 text-sm font-semibold ${stage === k ? "border-primary-strong bg-primary-strong text-primary-foreground" : "border-border bg-card hover:bg-muted"}`}>
              {STAGE_LABEL[k]}
            </button>
          ))}
        </div>
        <div className="mx-auto max-w-3xl rounded-2xl border border-dashed border-border p-3 sm:p-5">
          <AthleteHubHome key={stage} athlete={s.athlete} causeCount={0} onGo={() => {}} fixture={fixture} />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboardStates;
